type Valuation {
  valuation: Int
  range: ValuationRange
  breakdown: [ValuationFactor]
}

type ValuationFactor {
  estimate: Int
  method: String
  note: String
  weight: Int
}

type ValuationRange {
  from: Int
  to: Int
}
